import Seo from "@/components/site/Seo";
import PageHeader from "@/components/site/PageHeader";
import StoryChapters from "@/components/sections/StoryChapters";
import DevelopmentSection from "@/components/sections/DevelopmentSection";
import StayInLoop from "@/components/sections/StayInLoop";
import { IMG } from "@/lib/content";

export default function Story() {
  return (
    <>
      <Seo title="Our Story — RestPower" description="RestPower began with the idea that EV charging time could become useful, comfortable, and enjoyable. Read the story behind a better stop." path="/story" />
      <PageHeader
        overline="Our Story"
        title={<>Building a Better Stop.</>}
        intro="RestPower began with a simple idea: EV charging time could become useful, comfortable, and enjoyable — rather than time spent waiting in a parking lot."
        image={IMG.road}
      />
      <div className="py-8 md:py-16" />
      <StoryChapters />
      <DevelopmentSection />
      <StayInLoop />
    </>
  );
}
